module.exports = new __parcel__URL__("lock-red.0ce332f2.svg").toString();